'use strict';

const Obscura = require('backbone.obscura');

const { sortBy, contains, chain } = require('underscore');

class EventsFilteredCollection extends Obscura {
  getDates() {
    return sortBy(this.map(event => event.getDate()), date => date.toString());
  }

  getTimes() {
    return this.map(event => event.getTime());
  }

  getSections() {
    return this.map(event => event.getSection());
  }

  getQuantities() {
    const allQuantityOptions = this.map(event => event.getAllowedQuantities());
    return chain(allQuantityOptions)
      .flatten()
      .uniq()
      .sortBy(num => num)
      .value();
  }

  setDateFilter(date) {
    if (!date) {
      return false;
    }

    this.removeFilter('dates');
    this._selectedDate = date;
    return this.filterBy('dates', {
      date(eventDate) {
        return eventDate.isEqual(date);
      },
    });
  }

  setTimeFilter(time) {
    if (!time) {
      return false;
    }

    this.removeFilter('times');
    this._selectedTime = time;
    return this.filterBy('times', {
      time(eventTime) {
        return eventTime.isEqual(time);
      },
    });
  }

  setQuantityFilter(quantity) {
    if (!quantity) {
      return false;
    }

    this.removeFilter('quantities');
    this._selectedQuantity = quantity;
    return this.filterBy('quantities', event => contains(event.getAllowedQuantities(), quantity));
  }

  setSectionFilter(section) {
    if (!section) {
      return false;
    }
    this.removeFilter('sections');
    this._selectedSection = section;
    return this.filterBy(
      'sections',
      event =>
        event.getSection().getTitle() === section.getTitle() &&
        event.getSection().getPrice() === section.getPrice() &&
        event.getSection().getValue() === section.getValue()
    );
  }
}

module.exports = EventsFilteredCollection;
